import { Paper } from "@material-ui/core";
import { Maybe } from "graphql/jsutils/Maybe";
import InboxTask, { InboxTaskProps } from "./InboxTask";

interface InboxTasksComponentProps {
	tasks: Array<Maybe<InboxTaskProps>>;
}

const InboxTasksComponent: React.FC<InboxTasksComponentProps> = ({ tasks }) => {
	return (
		<Paper style={{ boxShadow: "none" }}>
			{tasks?.map((t: any, i: number) => (
				<InboxTask key={i} {...t} index={i} />
			))}
		</Paper>
	);
};

export default InboxTasksComponent;
